export default __webpack_public_path__ + "static/gatsby_github_get_pat5-827d23fe4d6707cc35c2fe5b3592a0bb.png";